(() => {
'use strict';
const root=document.getElementById('sbc-spitzen');
if(!root||root.dataset.initialized)return;
root.dataset.initialized='true';
const form=root.querySelector('#sbc-spitzen-form');
if(!form)return;
const choices=[...form.querySelectorAll('input[name="id"]')];
const modes=[...form.querySelectorAll('input[name="properties[Bearbeitungsbereich]"]')];
const price=form.querySelector('#sbc-spitzen-price');
const status=form.querySelector('#sbc-spitzen-status');
const submit=form.querySelector('#sbc-spitzen-submit');
const terms=form.querySelector('#sbc-spitzen-terms');
const quantity=form.querySelector('[name="quantity"]');
const sketch=form.querySelector('#sbc-spitzen-sketch');
const sketchError=form.querySelector('#sbc-spitzen-sketch-error');
const sketchRemove=form.querySelector('#sbc-spitzen-sketch-remove');
let sketchPending=false,sketchValid=true,validatedSketch=null,sketchVersion=0;
const money=c=>(c/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'});
const chosen=()=>choices.find(x=>x.checked)||null;
const chosenMode=()=>modes.find(x=>x.checked)||null;
const saleable=v=>!!(v&&v.dataset.available==='true'&&Number(v.dataset.cents)>0);
const sketchReady=()=>!sketchPending&&sketchValid&&(!sketch||!sketch.files.length||(sketch.files.length===1&&sketch.files[0]===validatedSketch));
function refresh(){
 const v=chosen();
 const selectedMode=chosenMode();
 const priced=Number(v?.dataset.cents||0)>0;
 const allowed=saleable(v);
 price.textContent=v&&priced?money(Number(v.dataset.cents)):'Preis nach Musterauswahl';
 choices.forEach(x=>x.closest('.sbc-spitzen__choice')?.classList.toggle('is-selected',x.checked));
 const qtyValid=!!(quantity&&Number.isSafeInteger(Number(quantity.value))&&Number(quantity.value)>0);
 const ready=allowed&&!!selectedMode&&terms.checked&&qtyValid&&sketchReady();
 submit.disabled=!ready;
 if(!v){status.textContent='Bitte ein Gripmuster auswählen.';submit.textContent='Gripmuster auswählen';}
 else if(!allowed){status.textContent='Dieses Gripmuster ist aktuell nicht verfügbar.';submit.textContent='Derzeit nicht verfügbar';}
 else if(!selectedMode){status.textContent='Bitte einen Bearbeitungsbereich auswählen.';submit.textContent='Bereich auswählen';}
 else if(sketchPending){status.textContent='Die Skizze wird geprüft.';submit.textContent='Skizze wird geprüft';}
 else if(!sketchReady()){status.textContent='Bitte eine gültige Skizze hochladen oder die Datei entfernen.';submit.textContent='Skizze prüfen';}
 else if(!qtyValid){status.textContent='Bitte eine gültige Anzahl Sets eingeben.';submit.textContent='Anzahl prüfen';}
 else if(!terms.checked){status.textContent='Bitte die AGB akzeptieren.';submit.textContent='AGB bestätigen';}
 else{status.textContent='Deine Auswahl ist bestellbar.';submit.textContent='In den Warenkorb · '+money(Number(v.dataset.cents));}
}
async function validateSketch(){
 const version=++sketchVersion;
 const file=sketch.files&&sketch.files[0];
 sketchPending=!!file;
 sketchValid=!file;
 validatedSketch=null;
 sketch.setCustomValidity('');
 if(sketchError){sketchError.textContent='';sketchError.hidden=true;}
 if(sketchRemove)sketchRemove.hidden=!file;
 refresh();
 if(!file)return;
 let message='';
 if(sketch.files.length!==1)message='Bitte genau eine Skizze auswählen.';
 else if(!file.size||file.size>12*1024*1024)message='Bitte eine nicht leere Datei mit maximal 12 MB auswählen.';
 else{
  try{
   const bytes=new Uint8Array(await file.slice(0,16).arrayBuffer());
   const ascii=Array.from(bytes,b=>String.fromCharCode(b)).join('');
   const ext=(file.name.split('.').pop()||'').toLowerCase();
   const png=bytes.slice(0,8).join(',')==='137,80,78,71,13,10,26,10';
   const jpg=bytes[0]===255&&bytes[1]===216&&bytes[2]===255;
   const webp=ascii.slice(0,4)==='RIFF'&&ascii.slice(8,12)==='WEBP';
   const pdf=ascii.startsWith('%PDF-');
   if(!((ext==='png'&&png)||(['jpg','jpeg'].includes(ext)&&jpg)||(ext==='webp'&&webp)||(ext==='pdf'&&pdf)))message='Bitte eine gültige PNG-, JPG-, WEBP- oder PDF-Datei auswählen.';
  }catch(error){message='Die Datei konnte nicht gelesen werden. Bitte erneut auswählen.';}
 }
 if(version!==sketchVersion)return;
 sketchPending=false;
 sketchValid=!message;
 validatedSketch=sketchValid?file:null;
 sketch.setCustomValidity(message);
 if(sketchError){sketchError.textContent=message;sketchError.hidden=!message;}
 refresh();
}
choices.forEach(x=>x.addEventListener('change',refresh));
modes.forEach(x=>x.addEventListener('change',refresh));
terms.addEventListener('change',refresh);
if(quantity)quantity.addEventListener('input',refresh);
if(sketch){
 form.setAttribute('enctype','multipart/form-data');
 sketch.addEventListener('change',validateSketch);
 if(sketchRemove)sketchRemove.addEventListener('click',()=>{
  sketch.value='';
  validateSketch();
  sketch.focus();
 });
}
form.addEventListener('submit',event=>{
 refresh();
 if(submit.disabled){event.preventDefault();status.focus?.();return;}
});
refresh();
if(sketch&&sketch.files.length)validateSketch();
})();